import { INSPECTION_GROUP_UNLABELED_COLOR } from '@editor/config/constants/group'
import { LineStyle, PolylineProps } from '@editor/interfaces/canvas'

export const DISTANCE_LABEL_STYLES: Partial<PolylineProps> = {
  label: {
    backgroundColor: 'lightgreen',
    color: '#000',
  },
  line: {
    style: LineStyle.Solid,
    color: INSPECTION_GROUP_UNLABELED_COLOR,
    thickness: 0.004,
  },
  lineOutline: {
    visible: false,
  },
}

// Working label
export const DISTANCE_LABEL_STYLES_WORKING_LABEL: Partial<PolylineProps> = {
  ...DISTANCE_LABEL_STYLES,
}

// For working polyline when it's being completed (the anchor is being hovered)
export const DISTANCE_LABEL_WORKING_COMPLETING: Partial<PolylineProps> = {
  ...DISTANCE_LABEL_STYLES_WORKING_LABEL,
  topAnchorProps: {
    ...DISTANCE_LABEL_STYLES_WORKING_LABEL.topAnchorProps,
    color: '#f00',
  },
  bottomAnchorProps: {
    ...DISTANCE_LABEL_STYLES_WORKING_LABEL.bottomAnchorProps,
    color: '#f00',
    outlineOpacity: undefined,
    icon: undefined,
    scale: undefined,
  },
  line: {
    color: '#f00',
  },
  lineOutline: {
    color: '#ffffff',
    visible: true,
  },
}

export const DISTANCE_LABEL_COMPLETED: Partial<PolylineProps> = {
  ...DISTANCE_LABEL_STYLES_WORKING_LABEL,
  topAnchorProps: undefined,
  bottomAnchorProps: undefined,
  line: {
    color: '#000000',
  },
  lineOutline: {
    color: '#ffffff',
    visible: true,
  },
}
